import { createSelector } from 'reselect';

export const selectedManagerHomePage = (state: any) => {
  return state.get('managerHomePage');
};

const makeSelectLastClaims = () =>
  createSelector(selectedManagerHomePage, managerHomeStore => {
    if (managerHomeStore && managerHomeStore.get('lastAssingnedClaims')) {
      return managerHomeStore.get('lastAssingnedClaims').toJS();
    }
    return [];
  });

const makeSelectSearchQuery = () =>
  createSelector(selectedManagerHomePage, managerHomeStore => {
    if (managerHomeStore && managerHomeStore.get('searchQuery')) {
      return managerHomeStore.get('searchQuery').toJS();
    }
    return {};
  });
const makeSelectResultSearchQuery = () =>
  createSelector(selectedManagerHomePage, managerHomeStore => {
    if (managerHomeStore && managerHomeStore.get('selectedResultSearch')) {
      return managerHomeStore.get('selectedResultSearch').toJS();
    }
    return {};
  });
export {
  makeSelectLastClaims,
  makeSelectSearchQuery,
  makeSelectResultSearchQuery,
};
